import { CanActivateFn } from '@angular/router';
import { createRoleGuard } from '../role/role.guard';
import { TSP } from '../../models';

/** Every route in `app.routes.ts` is admin-only, so widening access means adding to this list. */
export const ADMIN_PANEL_ALLOWED_ROLES: TSP.Internal.Recruiter.User.Role[] = [
  'SYSTEM_ADMIN' as TSP.Internal.Recruiter.User.Role,
];

export const authGuard: CanActivateFn = createRoleGuard(ADMIN_PANEL_ALLOWED_ROLES);
